import { FormControlLabel, FormHelperText, Radio, RadioGroup } from '@mui/material'
import React from 'react'
import { Controller, useWatch } from 'react-hook-form'
import { FormInputProps } from '../../../types/formInputProps'
import { GetLangloveDisabled } from '../../../functions/getLangloveDisabled'

interface CheBoxProps extends Omit<FormInputProps, 'label'> {
  forceValidate?: boolean
  forAdmin?: boolean
  forAdminLang1?: string | null
  forceupdate?: boolean
}

const FormInputLangLoves2: React.FC<CheBoxProps> = ({
  name,
  control,
  forceValidate,
  forAdminLang1,
}) => {
  const allOptions = [
    'Прикосновения',
    'Время',
    'Помощь',
    'Подарки',
  ]

  const watchedPrimary = useWatch({
    control,
    name: 'langlove',
    defaultValue: forAdminLang1 ?? (control as any)?._defaultValues?.langlove,
  })

  const primaryLang =
    watchedPrimary ||
    forAdminLang1 ||
    (control as any)?._defaultValues?.langlove ||
    (typeof window !== 'undefined' ? localStorage.getItem('prelanglove1') : null)

  const validate = (value?: string) => {
    if (forceValidate && !value) {
      return 'Выберите хотя бы один вариант'
    }
    return undefined
  }

  return (
    <Controller
      control={control}
      name={name}
      rules={{ validate }}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <>
          <div style={{ border: '2px solid', borderColor: '#8768c8', borderRadius: '10px' }}>
            <RadioGroup
              row
              aria-labelledby={`input-radio-${name}`}
              name={'position' + name}
              id={'input-radio-' + name}
              value={value || ''}
              onChange={(e) => {
                onChange(e.target.value)
              }}
              sx={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              {allOptions.map((option) => {
                const disabled = GetLangloveDisabled(option, primaryLang)
                const isChecked = !disabled && (value?.trim() ?? '') === option.trim()

                return (
                  <FormControlLabel
                    key={option + name}
                    value={option}
                    sx={{
                      color: 'white',
                      borderRadius: '5px',
                      backgroundColor: '#8768c8',
                      margin: '5px',
                      width: 'calc(50% - 10px)',
                      boxSizing: 'border-box',
                      maxWidth: '50%',
                    }}
                    label={option}
                    labelPlacement="start"
                    disabled={disabled}
                    control={
                      <Radio
                        sx={{
                          '&, &.Mui-checked': {
                            color: '#ffffff',
                          },
                        }}
                        checked={isChecked}
                      />
                    }
                  />
                )
              })}
            </RadioGroup>
          </div>
          {error && (
            <FormHelperText error style={{ textAlign: 'center', marginTop: '5px' }}>
              {error.message}
            </FormHelperText>
          )}
        </>
      )}
    />
  )
}

export default FormInputLangLoves2
